// hardcoded values for the colors of the graph

const colors = [
  {
    curve: '#E53E3E',
    point: '#FC8181',
    active: '#FC8181',
    gradient: '#C53030',
    background: '#E53E3E'
  },
  {
    curve: '#DD6B20',
    point: '#F6AD55',
    active: '#F6AD55',
    gradient: '#C05621',
    background: '#DD6B20'
  },
  {
    curve: '#D69E2E',
    point: '#F6E05E',
    active: '#F6E05E',
    gradient: '#B7791F',
    background: '#D69E2E'
  },
  {
    curve: '#38A169',
    point: '#68D391',
    active: '#68D391',
    gradient: '#2F855A',
    background: '#38A169'
  },
  {
    curve: '#319795',
    point: '#4FD1C5',
    active: '#4FD1C5',
    gradient: '#2C7A7B',
    background: '#319795'
  },
  {
    curve: '#3182ce',
    point: '#63b3ed',
    active: '#63b3ed',
    gradient: '#2b6cb0',
    background: '#3182ce'
  },
  {
    curve: '#805AD5',
    point: '#B794F4',
    active: '#B794F4',
    gradient: '#6B46C1',
    background: '#805AD5'
  }
]

export default colors
